import { Component, OnInit } from '@angular/core';
import { Vendor } from '../vendor';
import { VendorService } from '../vendor.service';

import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';


@Component({
  selector: 'app-vendors-list',
  templateUrl: './vendors-list.component.html',
  styleUrls: ['./vendors-list.component.css']
})
export class VendorsListComponent implements OnInit {

 
    currentPage = 1;
  itemsPerPage = 5;
  pageSize: number;
  vendor = new Vendor();  //Po is defined from abobe import po
  vendors: Vendor[];
  submitted = false;
	message: string;	
	  totalrecord:number;
  vendorFilter: any = { vendorname: '' };
  constructor(
    private vendorService: VendorService,
    private route: ActivatedRoute,
    private spinnerService: Ng4LoadingSpinnerService,
    private location: Location
  ) { }

  ngOnInit() {
    this.getVendors();
  }

  getVendors() {
    this.spinnerService.show();
    return this.vendorService.getVendorlist()
               .subscribe(
                vendors => {
                  console.log(vendors);
                  this.vendors = vendors
          this.totalrecord = this.vendors.length;
          this.spinnerService.hide();
                 }
                );
 }

 update(): void {
  this.submitted = true;
  this.vendorService.updateVendor(this.vendor)
      .subscribe(() => this.message = "Vendor Updated Successfully!");
}

delete(vendorid): void {
  //this.submitted = true;
  this.vendorService.deleteVendor(vendorid)
      .subscribe(()=> this.message = "Vendor Deleted Successfully!");
  this.getVendors();   
}


public changePagesize(num: number): void {
this.itemsPerPage = this.pageSize + num;
}

  public onPageChange(pageNum: number): void {
  this.pageSize = this.itemsPerPage*(pageNum - 1);
}

}
